export default {
  step1: {
    title: 'Submit Application',
    subtitle: 'Submitted on December 21st',
    rules: 'rules',
    rule1:
      '1. After applying for an invoice, the electronic invoice will be issued within 1-3 working days. If the qualification review is passed, the VAT special invoice (paper) will be mailed to you within 10 working days after the electronic invoice is issued;',
    rule2: '2. The invoiced amount will be the actual amount you paid;',
    rule3: '3. For any questions, please contact us directly at 13300001111.',
    contractName: 'Name',
    contractTips: 'Please select a contract name',
    invoiceType: 'Invoice type',
    amount: 'Amount',
    submit: 'Submit Application',
  },
  step2: {
    title: 'Electronic Information',
    subtitle: 'Contact Customer Service if you have any questions',
    invoiceTitle: 'Invoice Title',
    taxNum: 'Tax Num',
    address: 'Address',
    bank: 'Bank',
    bankAccount: 'Bank Account',
    email: 'Email',
    tel: 'Tel',
    invoiceTitlePlaceholder: 'please enter invoice title',
    taxNumPlaceholder: 'please enter tax num',
    addressPlaceholder: 'please enter address',
    bankPlaceholder: 'please enter bank',
    bankAccountPlaceholder: 'please enter bank account',
    emailPlaceholder: 'please enter email',
    telPlaceholder: 'please enter tel',
  },
  step3: {
    title: 'Invoice Mailed',
    subtitle: 'Contact us after the electronic invoice is issued',
    consignee: 'Consignee',
    mobileNum: 'Mobile Num',
    deliveryAddress: 'Address',
    fullAddress: 'Full Address',
  },
  step4: {
    title: 'Application Completed',
    subtitle: 'Contact Customer Service if you have any questions',
    finishTitle: 'Application is completed.',
    finishTips:
      'The electronic invoice is expected to be sent to your email within 1-3 working days. Please be patient for the delivery of the paper invoice.',
    reapply: 'reapply',
    check: 'check progress',
  },
  preStep: 'pre step',
  nextStep: 'next step',
};
